module.exports = __webpack_public_path__ + "static/media/MaternityLeave.0eac24cc.svg";